angular.module('ngApp')
.controller('loginPageController', ['$scope', '$state', function ($scope, $state) {
  if ($scope.user) {
    $state.go('index')
  }
}])
